module.exports = __webpack_public_path__ + "img/logo.ce634b3c.svg";